import React, { useEffect, useState, useContext } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import SpinWheel from "./SpinWheel/SpinWheel";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";

function FreeSpin() {
  const navigate = useNavigate();
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const closeFreeSpin = () => {
    navigate("/");
  };
  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 50);
    });
  }, []);
  return (
    <div className="App">
      <div id="cricket-page-wrapper" className="sport-page-wrapper">
        <div className="iframe-container">
          <SpinWheel profileData={profileData} />
        </div>
      </div>
    </div>
  );
}

export default FreeSpin;
